module.exports = __webpack_public_path__ + "static/media/topo_confirmacao.1266a905.jpg";